<template>
	<div class="xwrap">
		
		<!-- 先判断是否是在微信中打开，如果不是出遮罩，提示进入微信打开 -->
		<div class="wechatnologin" v-show="weixinopen" style="z-index: 999;">
			<div class="nomessage">请用微信打开本页面！</div>
		</div>
		
		<!-- 如果用户没有登录信息，且在微信中打开，那么显示一个白色遮罩 -->
		<div class="wechatnologin" v-show="wechatnologin" style="z-index: 900;">
			<div class="nomessage">您还没有登录，请登录后查看！</div>
			<div class="gotologBtn" @click="gologin">授权微信登录</div>
		</div>
		
		<div class="signwrap">
			<!-- 返回区域 -->
			<div class="gobackdetail" v-show="!textinp && vipnavshow" @click="gojumpback"><span class="el-icon-arrow-left"></span></div>
			
			<div class="signtop">
				<div class="signtopleft">
					<img src="../../assets/img/logo2.png" />
				</div>
				<router-link to="/" class="signtopright">https://xjaikj.htkjbd.com/</router-link>
			</div>
			
			<div class="signcenter">
				<div class="signtitle">项目签收单</div>
			    <ul class="signul">
			    	<!-- 表头 -->
			    	<li class="lione">
			    		<div class="lionediv1">项目名称</div>
			    		<div class="litwodiv1" v-show="!textinp && !changeinp">{{datamessage.project_name}}</div>
						<!-- 这是新增 -->
						<div class="litwodiv1" v-show="textinp"><input v-model="addname" class="projectname" type="text" placeholder="请输入名称"></div>
						<!-- 这是修改 -->
						<div class="litwodiv1" v-show="changeinp"><input v-model="addname" class="projectname" type="text"></div>
						
						<div class="lionediv2">项目编号</div>
						<div class="litwodiv2" v-show="!textinp && !changeinp">{{datamessage.number}}</div>
						<!-- 这是新增 -->
						<div class="litwodiv2" v-show="textinp"><input v-model="addnum" class="projectname" type="text" placeholder="请输入编号"></div>
						<!-- 这是修改 -->
						<div class="litwodiv2" v-show="changeinp"><input v-model="addnum" class="projectname" type="text"></div>
			    	</li>
					<!-- 项目情况 -->
					<li class="lione2">
						<div class="lionediv">项目情况</div>
						<div class="litwodiv shoujida" v-show="!textinp && !changeinp">{{datamessage.content}}</div>
						<!-- 这是新增 -->
						<div class="litwodiv" v-show="textinp">
							<!-- <input v-model="addcontent" class="projectcont" type="text" placeholder="请输入项目情况"> -->
							<textarea v-model="addcontent" class="projectcont" placeholder="请输入项目情况"></textarea>
						</div>
						<!-- 这是修改 -->
						<div class="litwodiv" v-show="changeinp">
							<!-- <input v-model="addcontent" class="projectcont" type="text"> -->
							<textarea v-model="addcontent" class="projectcont"></textarea>
						</div>
					</li>
					<!-- 项目验收 -->
					<li class="lione2 mobilelione">
						<div class="lionediv">项目验收</div>
						<div class="litwodiv" style="justify-content: center;">
							<el-button :size="btnsize" v-show="!check" class="litcontbutton" type="primary" @click='suresign' :disabled="vipnavshow">点击签收</el-button>
							<!-- <el-button :size="btnsize" type="danger" plain disabled v-show="userid">已验收</el-button> -->
							<!-- 已签收印章 -->
							<div class="yanshoudivs" v-show="check">
								<img  class="yiqianshou" src="../../assets/img/qianshou.png" />
							</div>
						</div>
					</li>
					<!-- 负责人 -->
					<li class="lione3 mobilelione">
						<div class="lionediv">负责人</div>
						<div class="litwodiv">
							<div class="yanshoudiv" v-if="check">
								<div class="wechart">
									<img :src="datamessage.check_user.headimgurl" />
									<span>{{datamessage.check_user.nickname}}</span>
								</div>
								<div class="yanshotext">已签收</div>
							</div>
						</div>
					</li>
				</ul>
				
				<div class="botomdes">
					<!-- <div class="botomdesleft">北京后天世纪文化传媒有限公司保定分公司</div> -->
					<div class="botomdesleft">北京中数后天科技有限公司</div>
					<div class="botomdesright" v-show="!textinp && !changeinp">{{datamessage.date}}</div>
					<el-date-picker
					      v-show="changeinp || textinp"
					      v-model="value1"
					      type="date"
						  class="timercheck"
					      placeholder="选择日期">
					</el-date-picker>
					<!-- 这是新增 -->
					<div class="botomdesright" style="margin-top: 10px;" v-show="textinp">
						<el-button @click="postnewdetail(1)" type="danger">确认提交</el-button>
					</div>
				</div>
				
				<!-- 修改按钮，只有当，不是新增状态下，以及是vip的时候，才会出现 -->
				<div class="botbutton" v-show="!textinp && vipnavshow">
				<!-- <div class="botbutton"> -->
					<el-button type="warning" @click="changebtn" :disabled="gaibtn">修改内容</el-button>
					<el-button type="danger" @click="postnewdetail(2)" :disabled="clickbtn">确认修改</el-button>
				</div>
				
				<!-- 浏览和确认记录的按钮 不是新增状态下，以及是vip的时候，才会出现-->
				<div class="botbutton mobilebtn" v-show="!textinp && vipnavshow">
				<!-- <div class="botbutton"> -->
					<el-button type="primary" @click="jumplook">浏览记录</el-button>
					<el-button type="success" @click="jumpsure">签收记录</el-button>
				</div>
			</div>
		</div>
		
		<!-- 提交成功后的弹窗 -->
		<div class="uploadtip" v-show="windowtip">
			<div class="uploadyin"></div>
			<div class="uploadcenter">
				<div>提交成功，点击确定返回列表页！</div>
				<el-button :size="btnsize" type="primary" @click="jumppage">确定</el-button>
			</div>
		</div>
		
		<!-- 修改成功弹窗 -->
		<div class="uploadtip" v-show="changesuccess">
			<div class="uploadyin"></div>
			<div class="uploadcenter">
				<div>修改成功</div>
				<el-button :size="btnsize" type="primary" @click="closegaitip">确定</el-button>
			</div>
		</div>
		
	</div>
</template>

<script>
	import $ from "jquery"
	import wx from 'weixin-js-sdk'
	import Headernew from '@/components/Headernew.vue'
	import Footernew from '@/components/Footernew.vue'
	
	export default {
	  name: 'checkdetail',
	  components: {
	    Headernew,
	    Footernew,
	  },
	  data() {
		return {
			user_id:'',//用户id
			userid:'',//是否签收，根据user_id字段判断，有就是有，没有就是null
			check:'',//用户是否签收过
			uid:'',//方案id
			signend:false,//控制签收头像，签收图片的显示
			datamessage:'',//签收单数据
			btnsize:'medium',//按钮尺寸
			wechatnologin:true,//控制微信打开页面时，未登录，显示的遮罩
			weixinopen:true,//控制，用微信打开本页面的提示显示和隐藏
			screenWidth: document.body.clientWidth,     // 屏幕宽
			textinp:false, //新增输入框的显示和隐藏
			changeinp:false,//修改的输入框的显示和隐藏
			addname:'',//新增项目名
			addnum:'',//新增项目编号
			addcontent:'',//新增项目情况
			editing:true,//编辑或新增状态下，不能点击签收
			windowtip:false,//修改成功的弹窗
			vipnavshow:false,//控制vip案例导航的显示和隐藏
			gaibtn:false,//控制修改按钮的禁用
			clickbtn:true,//控制修确认修改按钮的变灰
			value1:'',//选择时间
			changesuccess:false,//修改成功弹窗的显示和隐藏
		}
	  },
	  mounted() {
		  var that = this
		  // 这里是用来获取屏幕宽度的
		  window.onresize= () => {
		      return (() => {
		          window.screenWidth = document.body.clientWidth;
		          that.screenWidth = window.screenWidth;
		      })();
		  }
		  this.gologin() //执行微信登录和判断
		  this.getdata() //获取数据
		  this.share() //微信转发分享
	  },
	  methods:{
		  // 先判断是否在微信浏览器中，是的话就授权登录，不是就不能打开
		  gologin:function(){
			  var that = this
			  var newurl = window.location.href
			  // 只要是判断此时是在微信浏览器打开的这个页面，就执行登录
			   var ua = navigator.userAgent.toLowerCase();
			   var usersmessage = localStorage.getItem('usermessage');
			   if(ua.match(/MicroMessenger/i) == 'micromessenger'){
				   that.weixinopen = false
				   //说明用户是在微信中打开的
				   if(usersmessage){
					   var userid = JSON.parse(usersmessage).userid 
					   that.user_id = userid
					   
					   // 判断用户是不是vip，如果是vip就显示修改和提交确定按钮，不是就不显示
					   var admin = JSON.parse(usersmessage).adminid
					   if(admin==1){
					   		this.vipnavshow = true
					   }else{
					   		this.vipnavshow = false
					   }

					   // 已经登录
					   that.wechatnologin = false
					   
					   // 向后台提交浏览记录
					   var newdata = {
							user_id:userid,
							check_id:that.$route.query.checkid
						}
						this.$axios.post(this.$api + "/confirmsBrows",newdata)
					   .then(function (res) {
							//console.log(res)
						}).catch(function (err) {
							console.log(err)
						})  
						
				   }else{
					   //还没有登录
					   that.wechatnologin = true
					   // localStorage.setItem('geotourl',newurl)
					   document.cookie = 'retrunurl' +"="+ newurl

					   // 移动端用的是公众号的appid，pc端用的是公众平台的appid
					   var appid = 'wx799c2495cc0d2a30'
					   var urlx = 'http%3A%2F%2Fxjaikj.htkjbd.com%2Floginsucess%3Fappid%3Dwx799c2495cc0d2a30'
					   window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlx}&response_type=code&scope=snsapi_userinfo&state=STATUS#wechat_redirect`
					   // 跳转到loginsucess.vue页面，在域名上得到code
					  
					   
				   }
				   
			   }else{
				   // 提示请用微信打开
				   that.weixinopen = true
			   }
		  },
		  getdata:function(){
			  var that = this
			  if(this.screenWidth > 300 && this.screenWidth < 800){
				  this.btnsize = 'mini'
			  }else{
				  this.btnsize = 'medium'
			  }
			  
			  // 说明是正常点击进入的
			  if(that.$route.query.checkid){
				  
				  // 让输入框隐藏，让文本框显示
				  that.textinp = false
				  that.editing = false
				  
				  this.uid =this.$route.query.checkid
				  let uid =this.$route.query.checkid
				  let url = this.$api + "/getConfirmById/" + uid
				  this.$axios.get(url,{
						params:{
							user_id:that.user_id
						}
				  })
				  .then((res) => {
					  // 微信转发分享
					  // 这里是为了避免异步问题，所以将微信转发分享放在这个位置上
					  that.share(res.data.result.project_name) //微信转发分享
					  
					  that.datamessage = res.data.result
					  that.check = res.data.result.on_check
					  that.userid = res.data.result.user_id

					  //将数据也传递给，要修改的参数
					  that.addname = res.data.result.project_name
					  that.addnum = res.data.result.number
					  that.addcontent = res.data.result.content
					  that.value1 = res.data.result.date

				  })
				  .catch((err) => {
				  	console.log(err)
				  })
			  }else if(that.$route.query.newadd){
				  // 说明是点击添加进入的
				  // 让输入框隐藏，让文本框显示
				  that.textinp = true
				  that.editing = true
				  
			  }
			  
			  
		  },
		  // 确认签收
		  suresign:function(){
			  this.windowshow = false
			  this.signend = true
			  
			  var that = this
			  var usersmessage = localStorage.getItem('usermessage');
			  var userid = JSON.parse(usersmessage).userid 
			  let url = this.$api + "/saveConfirm/" + that.uid
			  this.$axios.post(url,{
				user_id:userid
			  })
			  .then((res) => {
				  // console.log(res)
				  that.check = true
				  that.datamessage.check_user = res.data.result
				  // console.log(that.datamessage)
				  // that.userid = res.data.result.user_id
			  })
			  .catch((err) => {
				console.log(err)
			  })
		  },
		  // 微信分享功能
		  share:function(newname){
		        var that=this
		  		var shareUrl = window.location.href
		  		this.$axios.get('https://htkja.htkjbd.com/api/get/jssdk?path=' + encodeURIComponent(shareUrl))
		  		.then(function (res) {
		  		   wx.config({
		  			 debug: false,// true开启调试模式,pc端会console.log手机端会alert
		  			 appId: res.data.result.appId,// 必填，公众号的唯一标识，填自己的！
		  			 timestamp: res.data.result.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
		  			 nonceStr: res.data.result.nonceStr,   // 必填，生成签名的随机串
		  			 signature: res.data.result.signature, // 必填，签名，见附录1
		  			 jsApiList: [
		  			   'onMenuShareTimeline',
		  			   'onMenuShareAppMessage'
		  			 ]
		  		   })
		  		
		  		   //分享配置
		  		   wx.ready(function () {
		  			   //分享到朋友圈
		  			   wx.onMenuShareTimeline({
		  				 // title: that.datamessage.content+'验收单',
		  				 title: '项目签收单',
		  				 link: 'https://xjaikj.htkjbd.com/checkdetail?checkid=' + that.uid,
		  				 imgUrl: 'https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/logo.png',
		  				 success: function () {
		  					  
		  				 },
		  				 cancel: function () {
		  				   // alert("取消分享"); 
		  				 }
		  			   });
		  			   //分享给朋友
		  			   wx.onMenuShareAppMessage({
		  				 // title: that.datamessage.content+'验收单',
		  				 title: '项目签收单',
		  				 desc: newname, 
		  				 link: 'https://xjaikj.htkjbd.com/checkdetail?checkid=' + that.uid,
		  				 imgUrl: 'https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/logo.png',
		  				 success: function () {
		  					 // alert('分享成功')
		  				 },
		  				 cancel: function (err) {
		  				     // alert("取消分享");
		  				    // alert(err)
		  				 }
		  			   });
		  		   })
		  		
		  		}).catch(function (err) {
		  												// alert(err)
		  								//        console.log(err)
		  		})  
		  		
		   },
		   // 提交新详情
		   postnewdetail:function(num){
			   var that = this
			   var addname = that.addname
			   var addnum = that.addnum
			   var addcontent = that.addcontent
			   
			   var date = new Date();
			   var years = date .getFullYear(); //获取完整的年份(4位)
			   var month = date .getMonth()+1; //获取当前月份(0-11,0代表1月)
			   var day = date .getDate(); //获取当前日(1-31)
			   
			   var newdate
			   
			   // 选了时间就要选择的时间，没选时间就用当前时间
			   if(that.value1==""){
				   newdate = years+'-'+month+'-'+day
			   }else{
					var newtime = that.value1
				   if(String(that.value1).indexOf('-')>0){
					   // 否则就是页面自带的时间
					   newdate = newtime
				   }else{
					   // 说明是勾选出来的时间
					   var newyears = newtime.getFullYear();
					   var newmonth = newtime.getMonth()+1;
					   var newday = newtime.getDate();
					   newdate = newyears+'-'+newmonth+'-'+newday
				   }
			   }
			   
			   if(addname!='' && addnum!='' && addcontent!=''){
				   
				   var newarry = {}
				   if(that.$route.query.newadd){
						   // 说明是新增，此时是没有id的
						   newarry.project_name = addname
						   newarry.content = addcontent
						   newarry.number = addnum
						   newarry.date = newdate
						   newarry.user_id = that.user_id
				   }else{
						   //说明是编辑进来的
						   newarry.id = that.$route.query.checkid
						   newarry.project_name = addname
						   newarry.content = addcontent
						   newarry.number = addnum
						   newarry.date = newdate
						   newarry.user_id = that.user_id
				   }
				   let url = this.$api + "/addConfirm"
				   this.$axios.post(url,newarry)
				   .then((res) => {
					   if(num==1){
						   // 说明是新增，跳转回列表页
						   that.windowtip = true
					   }else if(num==2){
						   // 修改后弹出修改成功，不跳转列表页面了
						   // 同时签收按钮要可以点击
						   this.editing = false
						   this.changeinp = false //点击确认修改后，就不能修改了
						   this.clickbtn = true //确认修改按钮不可以点击了
						   this.gaibtn = false //修改内容按钮可以点击了
						   // alert('修改成功！')
						   // 修改成功弹窗出现
						   this.changesuccess = true
						   // location.reload()
					   }
						   
						   // console.log(res)
				   })
				   .catch((err) => {
				   		console.log(err)
				   })
				   
			   }else{
				   alert('请将内容补充完整！！')
			   }
			   
		   },
		   closegaitip:function(){
				  this.changesuccess = false
				  // 重新刷新页面
				  location.reload()
		   },
		   // 返回列表页
		   jumppage:function(){
			   this.$router.push({path: '/checklist'})
		   },
		   // 点击修改按钮
		   changebtn:function(){
			   this.changeinp = true
			   this.editing = true
			   this.gaibtn = true //修改内容按钮不能点击了
			   this.clickbtn = false //确认修改按钮可以点击了
		   },
		   // 跳转浏览记录
		   jumplook:function(){
			   var that = this
			   var projectid = that.uid //项目id
			   var proname = that.datamessage.project_name //项目名称
			   this.$router.push({path: '/checklook?proname='+ proname})
		   },
		   // 跳转确认记录
		   jumpsure:function(){
			   var that = this
		   		var proname = that.datamessage.project_name //项目名称
		   		this.$router.push({path: '/checksure?proname='+ proname})  
		   },
		   // 点击返回上一页
		   gojumpback:function(){
		   			  this.$router.go(-1)
		   }
	  }
	}
	
</script>

<style scoped="scoped">
	router-link,a{
		text-decoration: none;
	}
	ul,li{
		margin: 0;
		padding: 0;
		list-style: none;
	}
	iframe {
		width: 1200px;
		height: 700px;
		border: none !important;
		margin: 0 !important;
	}
	/* 顶部返回按钮 */
	.gobackdetail{
		display: none;
	}
	/* 微信中打开，没有登录的话，显示的遮罩 */
	.wechatnologin{
		width: 100vw;
		height: 100vh;
		background-color: #fff;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1000;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.gotologBtn{
		width: 130px;
		height: 40px;
		color: #fff;
		line-height: 40px;
		background-color: #007400;
		margin-top: 20px;
		border-radius: 5px;
	}
	.gotologBtn:hover{
		cursor: pointer;
	}
	
	.navtop{
		width: 100%;
		height: 90px;
		background-color: #000;
	}
	.signwrap{
		width: 1200px;
		height: 300px;
		margin: 80px auto 0;
	}
	/* 顶部横线 */
	.signtop{
		width: 100%;
		height: 50px;
		/* border-bottom: #9A9999 1px solid; */
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.signtopleft img{
		width: 130px;
		height: auto;
	}
	.signtopright{
		font-size: 14px;
		color: #949494;
		line-height: 23px;
	}
	/* 表格 */
	.signcenter{
		width: 100%;
		height: auto;
		margin-top: 20px;
		padding-bottom: 150px;
		position: relative;
	}
	.signtitle{
		width: 100%;
		font-size: 26px;
		font-weight: bold;
		border: #9A9999 3px solid;
		box-sizing: border-box;
		border-bottom: none;
		height: 80px;
		line-height: 80px;
	}
	.signul{
		width: 100%;
		margin-top: 0;
		border: #9A9999 3px solid;
		box-sizing: border-box;
		/* border-radius: 5px; */
	}
	
	/* 表格 */
	.signcenter{
		width: 100%;
		height: auto;
		margin-top: 20px;
		padding-bottom: 150px;
		position: relative;
	}
	.signtitle{
		width: 100%;
		font-size: 26px;
		font-weight: bold;
		border: #9A9999 3px solid;
		box-sizing: border-box;
		border-bottom: none;
		height: 80px;
		line-height: 80px;
	}
	.signul{
		width: 100%;
		margin-top: 0;
		border: #9A9999 3px solid;
		box-sizing: border-box;
		/* border-radius: 5px; */
	}
	/* 项目名称 */
	.lione{
		display: flex;
		height: 70px;
		align-items: center;
		/* background-color: #ECEBEB; */
	}
	.lionediv1{
		width: 15%;
		height: 100%;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		border-right: #9A9999 3px solid;
		box-sizing: border-box;
		font-weight: bold;
	}
	.lionediv2{
		width: 15%;
		height: 100%;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		border-left: #9A9999 3px solid;
		border-right: #9A9999 3px solid;
		box-sizing: border-box;
		font-weight: bold;
	}
	.litwodiv1{
		width: 40%;
		height: 100%;
		text-align: center;
		line-height: 25px;
		display: flex;
		align-items: center;
		text-align: left;
		padding: 0 10px;
		box-sizing: border-box;
		font-size: 16px;
		color: #8A8888;
		/* font-weight: bold; */
	}
	.projectname{
		width: 90%;
		height: 80%;
		font-size: 16px;
		border: none;
		outline: none;
	}
	.projectcont{
		width: 99%;
		height: 90%;
		border: none;
		outline: none;
		font-size: 16px;
	}
	.litwodiv2{
		width: 30%;
		height: 100%;
		text-align: center;
		line-height: 70px;
		font-size: 16px;
		color: #8A8888;
		/* font-weight: bold; */
	}
	/* 项目情况 */
	.lione2{
		display: flex;
		height: 130px;
		align-items: center;
	}
	.lione3{
		display: flex;
		height: 100px;
		align-items: center;
	}
	.lionediv{
		width: 15%;
		height: 100%;
		text-align: center;
		display: flex;
		justify-content: center;
		align-items: center;
		border-top: #9A9999 3px solid;
		border-right: #9A9999 3px solid;
		box-sizing: border-box;
		font-weight: bold;
	}
	.litwodiv{
		width: 85%;
		height: 100%;
		text-align: center;
		border-top: #9A9999 3px solid;
		line-height: 25px;
		display: flex;
		align-items: center;
		text-align: left;
		padding: 0 10px;
		box-sizing: border-box;
		font-size: 16px;
		color: #8A8888;
		/* font-weight: bold; */
	}
	.shoujida{
		/* height: auto !important; */
		display: block;
		overflow: auto !important;
		padding: 5px 10px !important;
		border-bottom: #fff 5px solid;
		box-sizing: border-box;
	}
	/* 已签收印章 */
	.yanshoudivs{
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.yiqianshou{
		width: 260px;
		height: auto;
		/* position: absolute;
		right: 420px;
		bottom: 190px; */
		transform:rotate(-25deg)
	}
	/* 已验收信息 */
	.yanshoudiv{
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.wechart{
		display: flex;
		align-items: center;
	}
	.wechart img{
		width: 25px;
		border-radius: 50%;
	}
	.wechart span{
		font-size: 16px;
		font-weight: bold;
		margin-left: 5px;
		color: orange;
	}
	.yanshotext{
		font-size: 16px;
		font-weight: bold;
		margin-left: 10px;
	}
	/* 底部公司名称 */
	.botomdes{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 40px;
	}
	.botomdesleft,.botomdesright{
		font-size: 18px;
		font-weight: bold;
	}
	/* 提交成功后的弹窗 */
	.uploadtip{
		width: 100%;
		height: 100vh;
		position: fixed;
		left: 0;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.uploadyin{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.6);
		z-index: 1;
		position: absolute;
		left: 0;
		top: 0;
	}
	.uploadcenter{
		width: 400px;
		height: 200px;
		background-color: #fff;
		z-index: 2;
		border-radius: 5px;
	}
	.uploadcenter div{
		width: 100%;
		height: 60%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 16px;
		letter-spacing: 1px;
	}
	.botbutton{
		width: 100%;
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	
	/* 手机端样式 */
	@media (min-width: 300px) and (max-width: 500px){
		/* 顶部返回按钮 */
		.gobackdetail{
			width: 100%;
			margin-bottom: 20px;
			display: flex;
			justify-content: flex-start;
		}
		.gobackdetail span{
			font-size: 18px;
			font-weight: bold;
		}
		/* 时间选择 */
		.timercheck{
			margin-top: 15px;
		}
		/* 微信中打开，没有登录的话，显示的遮罩 */
		.wechatnologin{
			width: 100vw;
			height: 100vh;
			background-color: #fff;
			position: fixed;
			left: 0;
			top: 0;
			z-index: 1000;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		.gotologBtn{
			width: 130px;
			height: 40px;
			color: #fff;
			line-height: 40px;
			background-color: #007400;
			margin-top: 20px;
			border-radius: 5px;
		}
		.gotologBtn:hover{
			cursor: pointer;
		}
		.navtop{
			width: 100%;
			height: 90px;
			background-color: #000;
		}
		.signwrap{
			width: 93%;
			height: auto;
			margin: 20px auto 0;
		}
		/* 顶部横线 */
		.signtop{
			width: 100%;
			height: 40px;
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
		}
		.signtopleft img{
			width: 100px;
			height: auto;
		}
		.signtopright{
			font-size: 13px;
			line-height: 20px;
			color: #949494;
		}
		/* 表格 */
		.signcenter{
			width: 100%;
			margin-top: 10px;
			padding-bottom: 30px;
			position: relative;
		}
		.signtitle{
			font-size: 17px;
			font-weight: bold;
			width: 100%;
			border: #9A9999 2px solid;
			border-bottom: none;
			box-sizing: border-box;
			height: 60px;
			line-height: 60px;
		}
		.signul{
			width: 100%;
			margin-top: 0px;
			border: #9A9999 2px solid;
			box-sizing: border-box;
			/* border-radius: 5px; */
		}
		/* 项目名称 */
		.lione{
			display: flex;
			height: 90px;
			align-items: center;
			/* background-color: #ECEBEB; */
		}
		.lionediv1{
			width: 19%;
			height: 100%;
			font-size: 14px;
			text-align: center;
			line-height: 0px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-right: #9A9999 2px solid;
			box-sizing: border-box;
			font-weight: bold;
		}
		.lionediv2{
			width: 19%;
			height: 100%;
			font-size: 14px;
			text-align: left;
			line-height: 0px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-left: #9A9999 2px solid;
			border-right: #9A9999 2px solid;
			box-sizing: border-box;
			font-weight: bold;
		}
		.litwodiv1{
			width: 41%;
			font-size: 13px;
			height: 100%;
			text-align: left;
			line-height: 0px;
			display: flex;
			justify-content: center;
			line-height: 20px;
			align-items: center;
			padding: 0 5px;
			box-sizing: border-box;
			/* font-weight: bold; */
		}
		.projectname{
			font-size: 13px;
		}
		.projectcont{
			width: 99%;
			height: 90%;
			border: none;
			outline: none;
			font-size: 13px;
		}
		.litwodiv2{
			width: 21%;
			font-size: 13px;
			height: 100%;
			text-align: center;
			line-height: 0px;
			display: flex;
			justify-content: center;
			align-items: center;
			/* font-weight: bold; */
			box-sizing: border-box;
		}
		/* 项目情况 */
		.lione2{
			display: flex;
			height: 120px;
			align-items: center;
		}
		
		.mobilelione{
			height: 80px;
		}
		.lionediv{
			width: 19%;
			height: 100%;
			font-size: 14px;
			text-align: center;
			line-height: 0px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-top: #9A9999 2px solid;
			border-right: #9A9999 2px solid;
			font-weight: bold;
			box-sizing: border-box;
		}
		.litwodiv{
			width: 81%;
			font-size: 13px;
			height: 100%;
			text-align: left;
			line-height: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
			/* font-weight: bold; */
			padding: 0 10px;
			border-top: #9A9999 2px solid;
			box-sizing: border-box;
		}
		.shoujida{
			/* height: auto !important; */
			display: block;
			overflow: auto !important;
			padding: 5px 10px !important;
			border-bottom: #fff 5px solid;
			box-sizing: border-box;
		}
		/* 已签收印章 */
		.yiqianshou{
			/* width: 100px;
			height: auto;
			position: absolute;
			right: 0;
			top: 0px; */
			width: 170px;
			height: auto;
			/* position: absolute;
			right: 90px;
			bottom: 130px; */
			transform:rotate(-25deg)
		}
		/* 已验收信息 */
		.yanshoudiv{
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.wechart{
			display: flex;
			align-items: center;
		}
		.wechart img{
			width: 20px;
		}
		.wechart span{
			font-size: 14px;
			font-weight: bold;
			margin-left: 5px;
			color: orange;
		}
		.yanshotext{
			font-size: 14px;
			font-weight: bold;
			margin-left: 10px;
		}
		/* 底部公司名称 */
		.botomdes{
			width: 100%;
			display: block;
			margin-top: 20px;
		}
		.botomdesleft,.botomdesright{
			font-size: 14px;
			font-weight: bold;
		}
		.botomdesright{
			margin-top: 5px;
		}
		/* 提交成功后的弹窗 */
		.uploadtip{
			width: 100%;
			height: 100vh;
			position: fixed;
			left: 0;
			top: 0;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.uploadyin{
			width: 100%;
			height: 100%;
			background-color: rgba(0,0,0,0.6);
			z-index: 1;
			position: absolute;
			left: 0;
			top: 0;
		}
		.uploadcenter{
			width: 80%;
			height: 150px;
			background-color: #fff;
			z-index: 2;
			border-radius: 5px;
		}
		.uploadcenter div{
			width: 100%;
			height: 60%;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 15px;
			letter-spacing: 1px;
		}
		.botbutton{
			width: 100%;
			display: flex;
			justify-content: center;
			margin-top: 20px;
		}
		.mobilebtn{
			margin-bottom: 30px;
		}
		/* 提交成功和修改成功后的弹窗 */
		.uploadcenter{
			width: 80%;
			height: 150px;
			background-color: #fff;
			z-index: 2;
			border-radius: 5px;
		}
		.uploadcenter div{
			width: 100%;
			height: 60%;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 16px;
			letter-spacing: 1px;
		}
	}
	
	/* pad端样式 */
	@media (min-width: 500px) and (max-width: 800px){
		/* 顶部返回按钮 */
		.gobackdetail{
			width: 100%;
			margin-bottom: 20px;
			display: flex;
			justify-content: flex-start;
		}
		.gobackdetail span{
			font-size: 18px;
			font-weight: bold;
		}
		.navtop{
			width: 100%;
			height: 90px;
			background-color: #000;
		}
		.signwrap{
			width: 97%;
			height: auto;
			margin: 30px auto 0;
		}
		/* 顶部横线 */
		.signtop{
			width: 100%;
			height: 50px;
			/* border-bottom: #9A9999 1px solid; */
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
		}
		.signtopleft img{
			width: 130px;
			height: auto;
		}
		.signtopright{
			font-size: 14px;
			color: #949494;
			line-height: 23px;
		}
		/* 表格 */
		.signcenter{
			width: 100%;
			margin-top: 15px;
			padding-bottom: 50px;
			position: relative;
		}
		.signtitle{
			width: 100%;
			font-size: 20px;
			font-weight: bold;
			border: #9A9999 2px solid;
			border-bottom: none;
			height: 90px;
			line-height: 90px;
		}
		.signul{
			width: 100%;
			margin-top: 0;
			border: #9A9999 2px solid;
			/* border-radius: 5px; */
		}
		/* 项目名称 */
		.lione{
			display: flex;
			height: 90px;
			align-items: center;
			/* background-color: #ECEBEB; */
		}
		.lionediv1{
			width: 15%;
			height: 100%;
			text-align: center;
			line-height: 90px;
			border-right: #9A9999 2px solid;
			font-weight: bold;
		}
		.lionediv2{
			width: 15%;
			height: 100%;
			text-align: center;
			line-height: 90px;
			border-left: #9A9999 2px solid;
			border-right: #9A9999 2px solid;
			font-weight: bold;
		}
		.litwodiv1{
			width: 40%;
			height: 100%;
			line-height: 22px;
			display: flex;
			text-align: left;
			align-items: center;
			padding: 0 10px;
			box-sizing: border-box;
			/* font-weight: bold; */
		}
		
		.litwodiv2{
			width: 30%;
			height: 100%;
			text-align: center;
			line-height: 90px;
			/* font-weight: bold; */
		}
		/* 项目情况 */
		.lione2{
			display: flex;
			height: 160px;
			align-items: center;
		}
		.mobilelione{
			height: 100px;
		}
		.lionediv{
			width: 15%;
			height: 100%;
			text-align: center;
			line-height: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			border-top: #9A9999 2px solid;
			border-right: #9A9999 2px solid;
			font-weight: bold;
		}
		.litwodiv{
			width: 85%;
			height: 100%;
			text-align: left;
			border-top: #9A9999 2px solid;
			line-height: 22px;
			display: flex;
			align-items: center;
			padding: 0 10px;
			box-sizing: border-box;
			/* font-weight: bold; */
		}
		.shoujida{
			/* height: auto !important; */
			display: block;
			overflow: auto !important;
			padding: 5px 10px !important;
			border-bottom: #fff 5px solid;
			box-sizing: border-box;
		}
		/* 已签收印章 */
		.yiqianshou{
			width: 210px;
			height: auto;
			/* position: absolute;
			right: 240px;
			bottom: 150px; */
			transform:rotate(-25deg)
		}
		/* 已验收信息 */
		.yanshoudiv{
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		.wechart{
			display: flex;
			align-items: center;
		}
		.wechart img{
			width: 25px;
			border-radius: 50%;
		}
		.wechart span{
			font-size: 16px;
			font-weight: bold;
			margin-left: 5px;
			color: orange;
		}
		.yanshotext{
			font-size: 16px;
			font-weight: bold;
			margin-left: 10px;
		}
		/* 底部公司名称 */
		.botomdes{
			width: 100%;
			display: flex;
			justify-content: space-between;
			margin-top: 40px;
		}
		.botomdesleft,.botomdesright{
			font-size: 18px;
			font-weight: bold;
		}
	}
</style>
